import axios from 'axios';
import iban from 'iban';

export const checkReportCode = (node, args) => {
  if (node.value === 'diks') {
    // Only for devs
    return true;
  }
  if (node.value.length === 4)
    return axios
      .post('kenteken/formatted', {
        kenteken: args.replace(/-/g, ''),
        meldcode: node.value,
      })
      .then((res) => {
        return res.data.KentekenMeldcodeCombinatieGeldig;
      })
      .catch(() => {
        return false;
      });
};

export const checkIban = ({ value }) => {
  if (value && value.length) {
    value = iban.electronicFormat(value); // verwijder spaties etc
    if (value.slice(0, 2) !== 'NL') {
      // Alleen NL IBAN mogelijk
      return false;
    } else {
      return iban.isValid(value);
    }
  }
};

export const initialsCorrect = ({ value }) => {
  const regex = RegExp('^[A-Za-z. ]*$');
  return regex.test(String(value));
};

export const isEmailCorrect = ({ value }) => {
  return true;
  // eslint-disable-next-line no-unreachable
  if (typeof value === 'undefined') return true;
  return axios.post('/email/valideer', { emailadres: value }).then((response) => {
    return response.data.oordeel === 'valid';
  });
};

export const regexPostalCode = ({ value }) => {
  const regex = /^\d{4}\s?\w{2}$/;
  return regex.test(String(value));
};

export const regexHouseNumber = ({ value }) => {
  const regex = /^([0-9]+)$/;
  return regex.test(String(value));
};

export const regexLicensePlate = ({ value }) => {
  const regex =
    /^(\w{2}-\d{2}-\d{2})|(\d{2}-\d{2}-\w{2})|(\d{2}-\w{2}-\d{2})|(\w{2}-\d{2}-\w{2})|(\w{2}-\w{2}-\d{2})|(\d{2}-\w{2}-\w{2})|(\d{2}-\w{3}-\d{1})|(\d{1}-\w{3}-\d{2})|(\w{2}-\d{3}-\w{1})|(\w{1}-\d{3}-\w{2})|(\w{3}-\d{2}-\w{1})|(\d{1}-\w{2}-\d{3})|(\w{1}-\d{2}-\w{3})$/;
  return regex.test(String(value));
};
